export const initialState = {
  name: "",
  email: "",
  message: "",
};

export function reducer(state, action) {
  switch (action.type) {
    case "HANDLE_INPUT_TEXT": {
      return {
        ...state,
        [action.field]: action.payload,
      };
    }
    case "CLEAR_FORM": {
      return {
        ...initialState,
      };
    }
  }
  throw Error("Unknown action: " + action.type);
}
